import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../core/services';

@Injectable({
  providedIn: 'root',
})
export class PlatformDashboardApi {
  private readonly httpService = inject(HttpService);

  getDashboard() {
    return this.httpService.get('platform/dashboard');
  }
}
